import { render, staticRenderFns } from "./HostHistory.vue?vue&type=template&id=53f96049&"
import script from "./HostHistory.vue?vue&type=script&lang=js&"
export * from "./HostHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports